import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios)

export {axios, createAsyncThunk}


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/thunk-config.js